import { RefreshCw, Swords } from "lucide-react";
import PatchProgress from "@/components/launcher/PatchProgress";

export default function PatchPanel({ state, isHost, onCheck, onStart }) {
  const busy = state.phase === "checking" || state.phase === "downloading";
  return (
    <div className="mt-auto p-4 rounded-lg border border-white/5 bg-black/50 backdrop-blur-md space-y-4">
      <PatchProgress state={state} />
      <div className="flex gap-2">
        <button onClick={onCheck} disabled={busy} title="Sprawdź aktualizacje" data-testid="patch-check-btn"
          className="px-3 rounded-lg border border-amber-500/30 text-amber-300 hover:bg-amber-500/10 disabled:opacity-40 transition-colors">
          <RefreshCw size={18} className={busy ? "animate-spin" : ""} />
        </button>
        <button onClick={onStart} disabled={state.phase !== "done"} data-testid="start-game-button"
          className="btn btn-primary flex-1 !text-base">
          <Swords size={20} /> Uruchom grę
        </button>
      </div>
      {!isHost && <p className="text-[10px] text-slate-600" data-testid="launcher-preview-note">Podgląd w przeglądarce - kliknij odświeżanie, aby zasymulować aktualizację.</p>}
    </div>
  );
}
